export default __webpack_public_path__ + "static/media/single_side_crushers_end.608db206.svg";